import { useState, useEffect, useCallback } from 'react';

import {
  useClientContext,
  getNodeForm,
  FlowNodeEntity,
  WorkflowNodeJSON,
  WorkflowEdgeJSON,
} from '@flowgram.ai/free-layout-editor';
import { Button, Badge, Toast } from '@douyinfe/semi-ui';

import { saveWorkflowFun } from '../../utils/common';
import { saveWorkflow } from '../../https';

export function Save(props: { disabled: boolean }) {
  const [errorCount, setErrorCount] = useState(0);
  const clientContext = useClientContext();
  const urlParams = new URLSearchParams(window.location.search);
  const taskId = urlParams.get('taskId') || '';
  const executorName = urlParams.get('executorName') || '';

  const updateValidateData = useCallback(() => {
    const allForms = clientContext.document.getAllNodes().map((node) => getNodeForm(node));
    const count = allForms.filter((form) => form?.state.invalid).length;
    setErrorCount(count);
  }, [clientContext]);

  /**
   * Validate all node and Save
   */
  const onSave = useCallback(async () => {
    const allForms = clientContext.document.getAllNodes().map((node) => getNodeForm(node));
    await Promise.all(allForms.map(async (form) => form?.validate()));
    const data = clientContext.document.toJSON();
    console.log('>>>>> save data: ', clientContext.document.toJSON());
    // const { nodes, edges } = clientContext.document.toJSON();
    // const taskNodes = nodes.map((node: WorkflowNodeJSON) => ({
    //   number: node.id,
    //   type: node.type,
    //   name: node.data.title,
    //   taskId,
    //   meta: {...(node.meta?.position || {})},
    //   config: {...(node.data.fields || []).reduce((acc: Record<string, any>, cur: {key: string, value: any}) => ({...acc, [cur.key]: cur.value}), {})},
    // }));
    // const taskRelations = edges.map((edge: WorkflowEdgeJSON) => ({
    //   source: edge.sourceNodeID,
    //   target: edge.targetNodeID,
    // }));
    // console.log('>>>>> save data: ', {
    //   taskId,
    //   executorName,
    //   taskNodes: taskNodes as ITaskNode[],
    //   nodeRelations: taskRelations as INodeRelation[],
    // });
    try {
      await saveWorkflowFun(data, taskId, executorName);
      // await saveWorkflow({
      //   taskId,
      //   executorName,
      //   taskNodes: taskNodes as ITaskNode[],
      //   nodeRelations: taskRelations as INodeRelation[],
      // });
      // Toast.success('保存成功');
    } catch (error: any) {
      Toast.error(`保存失败: ${error.message || '未知错误'}`);
    }
  }, [clientContext]);

  /**
   * Listen single node validate
   */
  useEffect(() => {
    const listenSingleNodeValidate = (node: FlowNodeEntity) => {
      const form = getNodeForm(node);
      if (form) {
        const formValidateDispose = form.onValidate(() => updateValidateData());
        node.onDispose(() => formValidateDispose.dispose());
      }
    };
    clientContext.document.getAllNodes().map((node) => listenSingleNodeValidate(node));
    const dispose = clientContext.document.onNodeCreate(({ node }) =>
      listenSingleNodeValidate(node)
    );
    return () => dispose.dispose();
  }, [clientContext]);

  if (errorCount === 0) {
    return (
      <Button
        disabled={props.disabled}
        onClick={onSave}
        style={{ backgroundColor: 'rgba(171,181,255,0.3)', borderRadius: '8px' }}
      >
        保存
      </Button>
    );
  }
  return (
    <Badge count={errorCount} position="rightTop" type="danger">
      <Button
        type="danger"
        disabled={props.disabled}
        onClick={onSave}
        style={{ backgroundColor: 'rgba(255, 179, 171, 0.3)', borderRadius: '8px' }}
      >
          保存
      </Button>
    </Badge>
  );
}
